<div
  class="promotional-panel-container"
  [ngClass]="[
    isPromoBackFill ? 'background-nofill-container' : 'background-fill-container',
    isDisabledController ? 'is-disabled' : '',
    !isPTPO ? 'primary-account' : 'secondary-account',
  ]">
  <div class="promotional-panel" [ngClass]="[divider ? 'divider' : '']">
    <div
      id="techPeopleImageDesktop"
      [ngClass]="[isPromoBackFill ? 'background-nofill-container' : 'background-fill-container', !isPTPO ? 'col-sm-7' : '']"
      class="col-12 parent-promotion-container">
      <div
        [ngClass]="[
          isPromoBackFill ? 'background-nofill-container' : 'background-fill-container',
          !promoSlot?.isPromoAppType ? 'profile-container' : '',
        ]">
        <adp-image class="profile-img" aria-hidden="true" [imageKey]="promoSlot?.imageKey" style="width: 100%"></adp-image>
        <div class="tech-name-container"></div>
      </div>
    </div>
    <div
      [ngClass]="[isPromoBackFill ? 'background-nofill-container' : 'background-fill-container', !isPTPO ? 'col-sm-5' : '']"
      class="col-12 text-container"
      style="margin-top: 30px; text-align: center; padding-right: 10px">
      <span class="heading u-heading-4" style="font-size: 23px; color: #13223c; margin: auto"
        ><adp-label style="font-weight: 600; color: #13223c" [labelKey]="promoSlot?.heading"></adp-label
      ></span>
      <p class="desc u-body-1 promo-text-container promo-text-mobile-container">
        <adp-label [labelKey]="promoSlot?.promoText"></adp-label>
      </p>
      <button
        class="button-mobile-container"
        style="margin-left: auto; margin-right: auto; margin-top: 0px"
        *ngIf="!promoSlot?.isPromoAppType && promoSlot?.callToActionLabel"
        mat-flat-button
        color="accent"
        [disabled]="isDisabledController"
        (click)="letsChat()">
        <adp-label [labelKey]="promoSlot?.callToActionLabel"></adp-label>
      </button>
    </div>
    <div
      style="padding: 0px; width: 100%"
      id="techPeopleImageMobile"
      [ngClass]="[isPromoBackFill ? 'background-nofill-container' : 'background-fill-container', !isPTPO ? 'col-sm-7' : '']"
      class="col-12 parent-promotion-container">
      <div
        style="width: 100%; padding: 0px"
        [ngClass]="[
          isPromoBackFill ? 'background-nofill-container' : 'background-fill-container',
          !promoSlot?.isPromoAppType ? 'profile-container' : '',
        ]">
        <img style="width: 100%" [src]="imageKeyMobileUrl" [alt]="imageKeyMobileAlt" />
      </div>
    </div>
  </div>
</div>

